import { useMemo } from 'react';
import appRoutes from '~/appRoutes';
import { type DashboardTab, useDashboardTabs } from '~/hooks/useDashboardTabs';
import { useFormatMessage } from '~/intl';

export function useSupplyTabs() {
  const formatMessage = useFormatMessage();

  const tabs = useMemo<DashboardTab[]>(
    () => [
      {
        icon: 'BarChartIcon',
        id: 'dashboard',
        label: formatMessage({ id: 'navigation.dashboard' }, { count: 1 }),
        route: appRoutes.SUPPLY_VIEW,
      },
      {
        icon: 'TableLineIcon',
        id: 'custom-views',
        isDynamicRoute: true,
        label: formatMessage({ id: 'navigation.customTableViews' }),
        route: appRoutes.SUPPLY_VIEW_CUSTOM_VIEWS(),
      },
    ],
    [formatMessage],
  );

  return useDashboardTabs(tabs, {
    disabledTabValues: ['custom-table'],
    storageDefaultValue: 'dashboard',
    storageKey: 'supply-view.tab',
  });
}
